import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import * as actions from '@appStore/customers/actions';
import { CustomerRolesActionTypes, CustomerRolesLoadData } from '@appStore/customers/actions/customer-roles.actions';
import { CustomerService } from '@appStore/customers/services';

@Injectable()
export class CustomerRolesEffects {
  constructor(private customerService: CustomerService, private actions$: Actions) {}

  loadMyClientRoles$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerRolesActionTypes.CustomerRolesLoadData),
      exhaustMap((action: CustomerRolesLoadData) => {
        return this.customerService.getMyClientRoles(action.payload).pipe(
          map(clientRoles => new actions.CustomerRolesLoadSuccess(clientRoles)),
          catchError(error => of(new actions.CustomerRolesLoadFail(error)))
        );
      })
    );
  });
}
